import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const INSPECTORS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    AVAILABLE_INSPECTORS: '/available-inspectors/',
    INSPECTOR: (inspectorId: number) => `/inspectors/${inspectorId}`,
    DELETE_INSPECTOR_DOCUMENT: (inspectorId: number) =>
      `/delete-inspector-document/${inspectorId}/`,
    INSPECTOR_CATEGORIES: '/inspector-categories/',
    INSPECTOR_DETAIL: (id: number) => `/inspectors/${id}/`,
    ACADEMIC_MAJORS: '/academic-majors/',
    ASSIGN_INSPECTOR: (inspectorId: number) =>
      `/admin/inspectors/${inspectorId}/orders`,
    BULK_REASSIGN_INSPECTOR: (inspectorId: number) =>
      `/admin/bulk-reassign-inspector/${inspectorId}/orders`,
    SPECIAL_QUALIFICATIONS_TAGS: '/special-qualification-tags/',
    SPECIAL_QUALIFICATIONS_TAG_DETAIL: (id: number) =>
      `/special-qualification-tags/${id}/`,
    AVAILABLE_QCS: '/available-qcs/',
    ORDER_BY_EXPERT: `/order-experts/`,
    ORDER_BY_EXPERT_DETAIL: (orderId: number) => `/order-experts/${orderId}/`,
  }),
} as const;
